/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { DevIngestionRunDto } from './DevIngestionRunDto';
import {
    DevIngestionRunDtoFromJSON,
    DevIngestionRunDtoFromJSONTyped,
    DevIngestionRunDtoToJSON,
    DevIngestionRunDtoToJSONTyped,
} from './DevIngestionRunDto';
import type { DevIngestionStatus } from './DevIngestionStatus';
import {
    DevIngestionStatusFromJSON,
    DevIngestionStatusFromJSONTyped,
    DevIngestionStatusToJSON,
    DevIngestionStatusToJSONTyped,
} from './DevIngestionStatus';

/**
 * 
 * @export
 * @interface DevIngestionStatusDto
 */
export interface DevIngestionStatusDto {
    /**
     * 
     * @type {DevIngestionStatus}
     * @memberof DevIngestionStatusDto
     */
    status: DevIngestionStatus;
    /**
     * 
     * @type {Date}
     * @memberof DevIngestionStatusDto
     */
    lastScheduledRunAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DevIngestionStatusDto
     */
    nextScheduledRunAt: Date;
    /**
     * 
     * @type {Array<DevIngestionRunDto>}
     * @memberof DevIngestionStatusDto
     */
    runs: Array<DevIngestionRunDto>;
}



/**
 * Check if a given object implements the DevIngestionStatusDto interface.
 */
export function instanceOfDevIngestionStatusDto(value: object): value is DevIngestionStatusDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('lastScheduledRunAt' in value) || value['lastScheduledRunAt'] === undefined) return false;
    if (!('nextScheduledRunAt' in value) || value['nextScheduledRunAt'] === undefined) return false;
    if (!('runs' in value) || value['runs'] === undefined) return false;
    return true;
}

export function DevIngestionStatusDtoFromJSON(json: any): DevIngestionStatusDto {
    return DevIngestionStatusDtoFromJSONTyped(json, false);
}

export function DevIngestionStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevIngestionStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': DevIngestionStatusFromJSON(json['status']),
        'lastScheduledRunAt': (new Date(json['lastScheduledRunAt'])),
        'nextScheduledRunAt': (new Date(json['nextScheduledRunAt'])),
        'runs': ((json['runs'] as Array<any>).map(DevIngestionRunDtoFromJSON)),
    };
}

export function DevIngestionStatusDtoToJSON(json: any): DevIngestionStatusDto {
    return DevIngestionStatusDtoToJSONTyped(json, false);
}

export function DevIngestionStatusDtoToJSONTyped(value?: DevIngestionStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': DevIngestionStatusToJSON(value['status']),
        'lastScheduledRunAt': ((value['lastScheduledRunAt']).toISOString()),
        'nextScheduledRunAt': ((value['nextScheduledRunAt']).toISOString()),
        'runs': ((value['runs'] as Array<any>).map(DevIngestionRunDtoToJSON)),
    };
}

